import { DEFAULT_CAT_STATES } from "../common/constants/assignment-filters";
import { FilterToggleState } from "../types/assignment-filters";
import { IRequirement } from "../types/credential";

export const INSIGHT_PROJECT_SEARCH_QUERY_PARAM = "query";

const ASSIGNMENT_LABEL_SECTION_ID = "assignment_label";

const decodeUriComponentSafe = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const decodeBase64Safe = (value: string): string | null => {
  try {
    return globalThis.atob(value);
  } catch {
    return null;
  }
};

export const decodeInsightProjectSearchLabels = (
  encodedLabels: string | null,
): string[] => {
  if (!encodedLabels) {
    return [];
  }

  const decodedBase64 = decodeBase64Safe(decodeUriComponentSafe(encodedLabels));
  if (!decodedBase64) {
    return [];
  }

  const labels = decodedBase64
    .split(",")
    .map((label) => label.trim())
    .filter(Boolean);

  return Array.from(new Set(labels));
};

export const buildInsightAssignmentLabelRequirement = (
  labels: string[],
): IRequirement | undefined => {
  if (!labels.length) {
    return undefined;
  }

  const kwPrefix = DEFAULT_CAT_STATES[ASSIGNMENT_LABEL_SECTION_ID].kw_prefix;

  return {
    bool_str: `(${labels.map((label) => `${kwPrefix}:${label}`).join(" OR ")})`,
    section_id: ASSIGNMENT_LABEL_SECTION_ID,
    section_order: 0,
    section_type: FilterToggleState.MUST_HAVE,
  };
};
